<template>
  <div class="Investment-box equities-box">
    <div class="head-text">
      <ul class="breadcrumbs-list">
        <a href="javascript:void(0)"><li>FinTalk</li></a>
        <a href="javascript:void(0)" @click="backToCategory"><li>&nbsp;>&nbsp;Category</li></a>
        <a href="javascript:void(0)" @click="articals"><li>&nbsp;>&nbsp;Article</li></a>

        <a href="javascript:void(0)" @click="readArticle"><li>&nbsp;>&nbsp;Read Article</li></a>
        <li>&nbsp;>&nbsp;Full Article</li>
      </ul>
      <h1>{{type}}</h1>
    </div>
    <div class="d-flex justify-space-between">
    <div class="card-box equities-section custmized">
      <div class="artical-detail-top">
        <div class="d-flex justify-space-between artical-detail-content">
          <h1>{{title_name}}</h1>
          <p>Published: {{published_at}}</p>
        </div>
      </div>
      <div class="artical-detail-mid">
        <div class="artical-detail-imgbox">
          <div class="imgbox">
            <v-img min-height="260" max-width="700" :src="img" :lazy-src="img" title="Click here to read"> </v-img>
          </div>
        </div>
        <div class="artical-detail-mid-content">
          <p>  
            <b>Disclaimer:</b> {{disclaimer}}
          </p>
        </div>
        <div class="artical-detail-socialicon">
          <div class="d-flex justify-space-between">
            <div class="social-icon-box">
              <h2>Like & share below</h2>
              <div class="d-flex justify-center">
                <div>
                  <div class="imgbox">
                    <a v-if="likeKey == 'true'" @click="likeIt" data-reaction="Like"> <v-img max-height="30" max-width="30" :src="likeActive"> </v-img></a>
                    <a v-else @click="likeIt" data-reaction="Like"> <v-img max-height="30" max-width="30" :src="like"> </v-img></a>
                  </div>
                  <p>{{likes}} likes</p>
                </div>
                <div class="imgbox_btn">
                  <!-- <div class="imgbox">
                    <a @click=""><v-img max-height="30" max-width="30" :src="share"> </v-img></a>
                  </div> -->
                <v-menu
                bottom
                origin="center center"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div class="imgbox">
                    <v-btn class="v-share-btn" v-bind="attrs" v-on="on">
                     <v-img
                        max-height="30"
                        max-width="30"
                        :src="share"
                      >
                    </v-img>
                  </v-btn>
                </div>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <WhatsApp :url="share_report_url" scale="1.6" :title="title_name"></WhatsApp>
                    </v-list-item-title>
                    &nbsp;&nbsp;&nbsp;
                    <v-list-item-title>
                      <Telegram :url="share_report_url" scale="1.6"  :title="title_name"></Telegram>
                    </v-list-item-title>
                    &nbsp;&nbsp;&nbsp;
                    <v-list-item-title>
                      <Email :url="share_report_url" scale="1.6" :subject="title_name" :body="description"></Email>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
                </div>
              </div>
            </div>
            <div class="social-icon-box">
              <h2>Follow us on</h2>
              <div class="d-flex justify-center">
                <div class="imgbox">
                  <a href="https://www.facebook.com/nimeyaai/" target="blank"><v-img max-height="30" max-width="30" :src="facebook">
                  </v-img></a>
                </div>

                <div class="imgbox">
                  <a href="https://www.instagram.com/nimeya.ai/"
                    target="blank"><v-img max-height="30" max-width="30" :src="insta"> </v-img></a>
                </div>

                <div class="imgbox">
                  <a href="https://www.linkedin.com/company/nimeya-ai/"
                    target="blank"><v-img max-height="30" max-width="30" :src="linked"> </v-img></a>
                </div>

                <div class="imgbox">
                  <a href="https://nimeya.ai/"
                    target="blank"><v-img max-height="30" max-width="30" :src="website"> </v-img></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="articalhor"></p>
      <div class="d-flex justify-space-between">
        <div class="equities-item">
          <div class="d-flex justify-space-between artical-bottom-link">
            <h2>View more articles</h2>
            <a class=""  @click="articals()">See all</a>
          </div>

          <v-row>
            <template>
            <v-card class="mx-auto" outlined  v-for="(article_list_item,index) in similar_article_list" :key="index">
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="d-flex">
                    <div class="imgfield">
                      <v-img max-height="60" max-width="60" :src="titleIcon" :lazy-src="titleIcon">
                        </v-img>
                    </div>
                    <div class="contentfield">
                      <v-list-item-title
                        >{{article_list_item.title}}</v-list-item-title
                      >
                      <v-list-item-subtitle
                        >Published: {{article_list_item.created_at}}</v-list-item-subtitle
                      >
                      <a class="fullArtical" @click="readSimilarArticle(article_list_item.id)"
                        >Read full article</a
                      >
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </template>
          </v-row>
      </div>   
     </div>  

    </div>
       <div class="equities-item-box read-full-article">
          <template>
            <v-card
              v-for="categoryList in category"
              :key="categoryList.id"
              class="mx-auto"
              outlined
              @click="otherArticleLists(categoryList.id, categoryList.type)"
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline">
                    <v-img
                      max-height="39"
                      max-width="39"
                      :src="webIcon + categoryList.web_icon"
                    >
                    </v-img>
                  </div>
                  <v-list-item-title>{{ categoryList.type }}</v-list-item-title>
                </v-list-item-content>
                <v-btn
                  @click="otherArticleLists(categoryList.id, categoryList.type)"
                  text
                >
                  <v-img
                    max-height="30"
                    max-width="30"
                    src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                  >
                  </v-img>
                </v-btn>
              </v-list-item>
            </v-card>
          </template>
        </div>
  </div>
  </div>
</template>

<script>
import { WhatsApp, Telegram, Email } from 'vue-socialmedia-share';
import axios from "axios";
import JwtService from "../.././common/jwt.service";

export default {
   components: {
        WhatsApp,
        Telegram,
        Email,
    },
  data: function () {
    return {
      arrowRight: './bondimg.png',
      facebook: './facebook.svg',
      insta: './instagram.svg',
      share: './shareicon.png',
      like: './likeicon.png',
      likeActive: './like_active.svg',
      linked: './linkedin.svg',
      website:'./domain.svg',
      img:'',
      type: this.$route.params.category_name ,
      article_id: this.$route.params.article_id ,
      title_name:this.$route.params.title,
      description:this.$route.params.description,
      published_at:this.$route.params.published_at,
      similar_article_list:this.$route.params.similar_article_list,
      cat_id:this.$route.params.category,
      category: [],
      article_list: [],
      webIcon: process.env.VUE_APP_ROOT_ICONS_URL,
      titleIcon:this.$route.params.titleIcon,    
      share_report_url:window.location.origin+'/viewArticle?title='+this.$route.params.title+'&&type=fintalk',
      likes:0,
      likeKey:'',
      disclaimer:'',
      category: [],
      mai_cat: [],
    };
  },
  mounted() {
    this.readFinTalkArticle()
    this.showLikeCount()
  },
  methods: {
    likeIt(){
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let formdata = new FormData();
      formdata.append('aws_cognito_id', cognito_idp);
      formdata.append('article_id', this.article_id);
      formdata.append('type', 'like');
      axios
        .post(
          process.env.VUE_APP_ROOT_API + 'fintalk-like-articles',
          formdata,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        .then((response) => {
          this.likeKey = response.data.data.like;
          this.showLikeCount()
        });
    },
    showLikeCount(){
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let formdata = new FormData();
      formdata.append('aws_cognito_id', cognito_idp);
      formdata.append('article_id', this.article_id);
      axios
        .post(
          process.env.VUE_APP_ROOT_API + 'show-like-count',
          formdata,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        .then((response) => {
          this.likes = response.data.count;  
          this.likeKey = response.data.is_like;       
        });
    },
    backButton() {
      this.$router.push({
        name: 'FinTalkCategory',
        params: {},
      });
    },
    articals(){
        this.$router.push({
          name: 'FinTalkArticles',
          params: { category: this.cat_id, category_name: this.title_name, props: true },
        });
     },

    readSimilarArticle(id, type){
         this.article_id  = id
         this.readFinTalkArticle()
    },
    otherArticleLists(category_id, type) {
       this.$router.push({
          name: 'FinTalkArticles',
          params: { category: category_id, category_name: type, props: true },
        });
    },
    backToCategory(){
      this.$router.push({ name: "FinTalkCategory"}).catch(()=>{});
    },

    readArticle(id) {
      this.$router
        .push({
          name: 'ReadFintalkArticle',
          params: { article_id: this.article_id, category_name: this.type, props: true },
        })
        .catch(() => {});
    },
    readFinTalkArticle(){
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let formCatData = new FormData();
      formCatData.append('aws_cognito_id', cognito_idp);
      axios
        .post(
          process.env.VUE_APP_ROOT_API + 'fintalk-categories-listing',
          formCatData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        .then((response) => {
          this.category = [];
          response.data.data.forEach((element) => {
            if (element.id != this.fn_cat_id) {
              this.category.push(element);
            }
          });
          this.mai_cat = response.data.data;
        });

        
        let formdata = new FormData();
        formdata.append('aws_cognito_id', cognito_idp);
        formdata.append('article_id', this.article_id);
        axios
          .post(
            process.env.VUE_APP_ROOT_API + 'read-fintalk-article',
            formdata,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
              },
            }
          )
          .then((response) => {
            this.img = response.data.data.image_without_logo
            this.description  = response.data.data.description
            this.title_name  = response.data.data.title
            this.published_at  = response.data.data.created_at
            this.titleIcon = process.env.VUE_APP_ROOT_ICONS_URL + response.data.cat_detail.web_icon
            this.similar_article_list = response.data.similar_article_list
            this.cat_id = response.data.data.fintalk_category_id
            this.disclaimer  = response.data.fintalk_disclaimers.disclaimer
            this.article_id  = response.data.data.id
            this.type  = response.data.cat_detail.type
          });
     },
  },
};
</script>

<style scoped>
  .social-icon-box p {
    opacity: 1 !important;
  }
</style>